export default __webpack_public_path__ + "static/marius-a4ce5ee0cd423b388b697c55f74ef3ad.jpg";